export default __webpack_public_path__ + "static/media/patient-medical-history-form.6d992d0b.jpeg";